export default __webpack_public_path__ + "cb0bf22dc8e6249e2c397dd8bbbb4c9f.png";